<template>
  <div class="space-y-2">
    <div class="relative">
      <div :class="elementClasses" @click="toggleList">
        <slot name="placeholder">
          {{ placeholder || (value && label) ? value[label] : 'Select ...' }}
        </slot>
      </div>
      <ul
        v-if="showList"
        key="item-list"
        class="absolute bg-white border border-gray-400 w-full mt-2 mb-8 rounded z-10"
      >
        <li class="p-2">
          <input
            ref="searchList"
            :disabled="loading"
            type="text"
            class="input"
            :placeholder="$t('search')"
            @keypress.enter.prevent="search"
            @change="search"
          />
        </li>
        <li v-if="loading" key="loading" class="px-6 py-3 text-center">
          <Loader />
        </li>
        <li
          v-else
          v-for="(item, index) in items"
          :key="index"
          @click="setValue(item)"
          @keypress.enter="setValue(item)"
        >
          <slot name="item" :item="item" :index="index">
            {{ label ? item[label] : item }}
          </slot>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuickFinder',
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    loading: Boolean,
  },
  data: () => ({
    showList: false,
    current: null,
  }),
  computed: {
    elementClasses() {
      return [
        'w-full',
        'text-white',
        'border-indigo-600',
        'border',
        'rounded',
        'bg-indigo-500',
        'px-4',
        'py-3',
        'leading-normal',
      ];
    },
  },
  methods: {
    search(ev) {
      this.$emit('changed', ev.target.value);
    },
    toggleList() {
      this.showList = !this.showList;
      if (this.showList) {
        this.$nextTick(() => {
          this.$refs.searchList.focus();
        });
      }
    },
    setValue(value) {
      this.$emit('input', value);
      this.toggleList();
    },
  },
};
</script>
